import { ImageField, imageMobileField, LinkField, StringField, CardFields, CardProps } from '../../types/types';

export class CardModel {
  private readonly fields?: CardFields;
  constructor(props: CardProps) {
    this.fields = props.fields;
  }

  get all(): CardProps {
    return {
      fields: {
        title: this.title,
        subtitle: this.subtitle,
        image: this.image,
        mobileImage: this.mobileImage,
        link: this.link,
      },
    };
  }

  get title(): StringField {
    return this.fields?.title || {};
  }

  get subtitle(): StringField {
    return this.fields?.subtitle || {};
  }

  get image(): ImageField {
    return this.fields?.image || {};
  }

  get mobileImage(): imageMobileField {
    return this.fields?.mobileImage || {};
  }

  get link(): LinkField {
    return this.fields?.link as LinkField;
  }
}
